import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "eaa0984f-1360-47ed-9e40-c1c3df249870", content: "modulation frequency", options: {} },
  { id: "8d561b1d-4733-4dfd-ab88-122f7937b34d", content: "modulation depth", options: {} },
  { id: "c2175869-ef91-4734-bc4c-79acd27c3280", content: "center frequency", options: {} },
  { id: "367afc2d-5ec8-41f4-8be6-397afb855f47", content: "tonality", options: {} },
  { id: "a222dc44-1a3c-4240-a35b-bcea3c513342", content: "signal level", options: {} },
  { id: "d9ec388b-2703-4612-a869-1e315310c8cd", content: "sharpness", options: {} },
];

export const task: Task = {
  id: "940f9777-35a7-442f-a19f-9dc6b1cecaed",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "eaa0984f-1360-47ed-9e40-c1c3df249870",
    "8d561b1d-4733-4dfd-ab88-122f7937b34d",
    "c2175869-ef91-4734-bc4c-79acd27c3280",
  ],
};
